import { render, staticRenderFns } from "./FormOther.vue?vue&type=template&id=31a47205"
import script from "./FormOther.vue?vue&type=script&lang=js"
export * from "./FormOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports